export default "__VITE_ASSET__D941gPPg__"